import { useCallback } from 'react';
import { useGetProfile, useUpdateProfile } from '../api/hooks';
import { useProfileSaveFeedback } from './useProfileSaveFeedback';

export const useUpdateLanguage = () => {
	const { data: profile } = useGetProfile();
	const { onUpdated, onFailed } = useProfileSaveFeedback();

	const { mutate, isPending } = useUpdateProfile({ onUpdated, onFailed });

	const updateLanguage = useCallback(
		(locale: string) => {
			if (!profile) return;

			mutate({ email: profile.email, fullName: profile.fullName, locale });
		},
		[profile, mutate],
	);

	return { updateLanguage, isSaving: isPending };
};
